import React, { useEffect, useState, useContext } from "react";
import CardContent from "@material-ui/core/CardContent";
import API from "../../services/api";
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import GetAppIcon from '@mui/icons-material/GetApp';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
// import { ReactComponent as CreateNewFolderIcon } from "../../assets/folder.svg";
// import { ReactComponent as GetAppIcon } from "../../assets/download.svg";
// import { ReactComponent as Activedownload } from "../../assets/activedownload.svg";
// import { ReactComponent as ThumbPrint } from "../../assets/auto_fix_high_black_18dp.svg";
import "./style.css";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Amplitude from "amplitudejs";
import TrackContext from "../../contexts/track-context";
import Tabs from "@material-ui/core/Tabs";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
// import { ReactComponent as Play } from "../../assets/play.svg";
// import { ReactComponent as Pause } from "../../assets/pause.svg";
import { ReactComponent as Close } from "../../assets/close.svg";
import AlternateTracks from "./alternate-tracks";
import CookieManager from "../../services/CookieManager";
import { Link, useHistory, useParams } from 'react-router-dom';
import { BouncingLoader } from "../../pure-components/Loader";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { toast } from "react-toastify";
import { ErrorToast, SuccessToast } from "../../pure-components/CustomToast";
import RippleLoader from "../../assets/loader-2.gif";
import Helper from "../../services/helper";
import defaultImage from "../../assets/default_music.png";
import Constants from "../../services/constants";
import SvgInline from "../../pure-components/SvgInLine";
import MewoService from "../../services/mewoService";
import { Box, CircularProgress, Divider, Popover, Typography } from "@material-ui/core";
import HarvestService from "../../services/harvestService";
import WaveformWithHighlights from "../../pure-components/SvgInLine/waveformWithHighlights";
import LyricsOutlinedIcon from '@mui/icons-material/LyricsOutlined';
import JoinInnerIcon from '@mui/icons-material/JoinInner';
import { DownloadIcon } from "../NewUI/icons";
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import {
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function Track(props) {

  let trackContext = useContext(TrackContext);
  const { filterMenu, setFilterMenu, setFilterSubMenu, setFilterSubMenuchild } = trackContext;
  const [favs, setFavs] = useState([]);
  const [download, setDownload] = useState([]);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadModalPosition, setDownloadModalPosition] = useState(null);
  const [ChidDownloadModalPosition, setChilddownloadModalPosition] = useState(null);
  const [hdmp3File, setHdmp3File] = useState(false);
  const [originalFile, setOriginalFile] = useState(false);
  const [alternateVersions, setAlternateVersions] = useState([]);
  const [expand, setExpand] = useState(false);
  const [showLoader, setShowLoader] = useState(false)
  const { searchTags } = trackContext.trackFilter;
  const history = useHistory();
  const { playlistId, albumId } = useParams()
  const [versionLoading, setVersionLoading] = useState(false);
  const [downloadingTrack, setDownloadingTrack] = useState("");

  const [showLyricModal, setShowLyricModal] = useState(false);
  const [lyricModalPosition, setLyricModalPosition] = useState(null);
  const [isHovered, setIsHovered] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl(null);
  };
  
  useEffect(() => {
    if (localStorage.getItem("favs") && localStorage.getItem("favs") !== 'undefined' && localStorage.getItem("favs") !== 'null') {
      const favorites = JSON.parse(localStorage.getItem("favs") || "{}");
      if(Object.keys(favorites)?.length > 0)
        setFavs(Object.keys(favorites));
    }
    if (localStorage.getItem("download") !== "undefined") {
      const download = JSON.parse(localStorage.getItem("download"));
      download !== null && setDownload(download);
    }
  }, []);

  const fetchTrack = (trackId, isAltVersion ,description= false) => {
    console.log("fetchTrack description", { isAltVersion });
    console.log("fetchTrack called with:", { trackId, isAltVersion });
  
    if (trackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === props.pageId) {
      console.log("Toggling play/pause for the same track");
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
  
    if (Amplitude.getSongs().length) {
      console.log("Stopping and removing the current song from Amplitude");
      Amplitude.stop();
      Amplitude.removeSong(0);
    }
  
    trackContext.setpreviousTrack(props.previousTrack);
    console.log("Previous Track Set:", props.previousTrack);
  
    props.setFetchingTrack(true);
    console.log("Fetching track data...");
  
    API.playTrack(trackId)
      .then((res) => {
        props.setFetchingTrack(false);
        console.log("API Response:", res);
  
        if (res?.data?.success) {
          const trackData = res.data.data;
          const artistData = trackData.artists_publishing_ownerships;
  
          console.log("Artist Data from API:", artistData);
  
          const artist = artistData?.length > 0 ? artistData[0]?.artist?.full_name : "Unknown Artist";
          const description = artistData?.length > 0 ? artistData[0]?.description?.description : "Unknown Artist";          
          const artistType = artistData?.length > 0 ? artistData[0]?.rights_type?.key : "Unknown Type";
  
          // Fetching music description
          console.log(trackData,"trackData") 
  
          console.log("Extracted Artist:", artist);
          console.log("Extracted Artist Type:", artistType);
          console.log("Extracted Music Description:", description);
  
          trackContext.setPlayingFrom(props.pageId);
          trackContext.setalltrackData(trackContext.trackData);
          trackContext.setCurrentTrack(trackData.audiofile);
  
          trackContext.setCurrentTrackDetail({
            ...trackData,
            tags: props.tags,
            artist: artist,
            artist_type: artistType,
            description: description, // Added description here
          });
  
          console.log("Updated Track Details:", {
            tags: props.tags,
            artist: artist,
            artist_type: artistType,
            description: description,
          });
        } else {
          console.error("API Error:", res?.data);
          Helper.handleError(res?.data);
        }
      })
      .catch((error) => {
        console.error("API Call Failed:", error);
        Helper.handleError(error);
      });
  };

  const playTrack = async(trackData) => {
    if (trackData.trackId === trackContext.currentTrackDetail.id && trackContext.playingFrom === props.pageId) {
      // console.log("Toggling play/pause for the same track");
      trackContext.setPlayPause(!trackContext.playPause);
      return;
    }
  
    if (Amplitude.getSongs().length) {
      // console.log("Stopping and removing the current song from Amplitude");
      Amplitude.stop();
      Amplitude.removeSong(0);
    }

    trackContext.setPlayingFrom(props.pageId)
    trackContext.setCurrentTrack(Helper.playTrackURL(trackData.trackId));
    trackContext.setCurrentTrackDetail({id : trackData.trackId, 
      display_title : trackData.title,
      description : trackData.description || "",
      duration : trackData.duration,
      bpm : trackData.bpm, 
      album : {id : trackData.albumId, name : trackData.album, image : {original : {url : Helper.getArtworkURL(trackData.albumId)}}},
      artist: trackData.artistName,
      isVersion : trackData.isVersion || false,
      highlights : trackData.highlights
    });
    
    const dataObj = {
      actionType : Constants.ACTION.PLAY,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.albumId,
        albumName : trackData.album,
        artistName : trackData.artistName,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    } 
    await API.addPlayHistory(dataObj).then((res) => {
      if (res.success) {
        localStorage.setItem("history", JSON.stringify(res.history)); 
      } else {
        console.log("Track Adding in play history failed.", res);
      }
    }).catch(err => {
      console.log("Track Adding in play history failed.", err);
    });
  }

  const magicWandSearch = (trackData) => {
    //TODO : change this as we change musicFilter obj
    if (!trackContext.validateUser(Constants.ACTION.SEARCH)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.SEARCH);
      return;
    }
    const tempFilter = CookieManager.getCookie("harmix-music-filter")?.length > 0 ? JSON.parse(decodeURIComponent(CookieManager.getCookie("harmix-music-filter"))) : { "searchText": "", "type": Constants.SEARCH_TYPE.text };
    tempFilter.type = Constants.SEARCH_TYPE.track;
    tempFilter.searchText = trackData.title;
    tempFilter.searchRef = trackData.id;
    tempFilter.segment = null;
    CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify(tempFilter)));
    CookieManager.setCookie("searched-track-data", encodeURIComponent(JSON.stringify(trackData)));
    history.push(`/library/${trackData.id}`, {searchedTrackData : {...trackData}})
  }

  const downloadTrack = async (trackId, format = "mp3") => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
      props.setDownloadingTracks([...props.downloadingTracks, trackId])
      const filter = {
        "Identifier": trackId,
        "DownloadType": "track",
        "Format": format,
        "TrimStartSecs": 0,
        "TrimEndSecs": 0,
        "Email": cachedUserData.email,
        "IsShare": false,
        "Message": "",
        "SenderEmail": "",
        "ForceEmail": false,
        "IncludeVersions": false,
        "VersionFolderName": "",
        "DownloadFileName": "",
        "CuesheetFileName": "",
        "IncludeCuesheetFile": false
      }

      await API.downloadTrack(filter).then(resp => {
        if(resp.success){
          toast(({ closeToast }) => <SuccessToast message={"Request processed. Download will begin shortly."} />);
          // console.log("track download resp : ", resp);
          if(resp.data?.DownloadTokens?.length > 0){
            const accessURLs = JSON.parse(localStorage.getItem("resourceURL")|| "{}");
            if(accessURLs?.DirectDownloadURL?.length > 0){
              const downloadURL = accessURLs.DirectDownloadURL.replace("{downloadtoken}", resp.data.DownloadTokens[0].TokenValue)
              const link = document.createElement('a');
              link.href = downloadURL;
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            }
          }
        }
        else
          toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + resp.mssg || resp.err} />);
      }).catch(err =>{
        // console.log("Track download error : ", err);
        toast(({ closeToast }) => <ErrorToast message={"Track download Error : " + err.mssg || err} />);
      }).finally(() => {
        const tempData = props.downloadingTracks;
        tempData?.length > 0 && tempData.splice(tempData.indexOf(trackId), 1);
        props.setDownloadingTracks(tempData);
      })

  };

  const handleDownloadClick = async(event) => {
    setDownloadModalPosition(event.currentTarget);
    setChilddownloadModalPosition(event.currentTarget);
    setShowDownloadModal(true);
  }

  const handleLyricClick = async(event) => {
    setLyricModalPosition(event.currentTarget);
    setShowLyricModal(true);
  }

  const fetchAltVersion = async (trackId, altVersionCount, expandval = false) => {
  if (expandval) {
      
      setVersionLoading(true);
      const filter = {
        "ReturnAlternateVersions":"true",
        "ReturnAttributes":"true",
        "ReturnCategories":"true",
        "ReturnCategoryFacet":"true",
        "ReturnCodes":"true",
        "ReturnComposers":"true",
        "ReturnRelatedTracks":"false",
        "ReturnRightHolders":"false",
        "GetMainVersionFromAlternate":"false",
        "CuesheetOnlyCodesAndAttribute":"false",
        "ReturnInactiveTracks":"false",
        "ReturnRegionOnlyTracks":"false",
        "Offset":"0",
        "Limit":"100",
        "track":[trackId]
      }
      let trackVersions = [];
      if(altVersionCount > 0){
        const reqObj = {
          refUrl : `/gettracks/{memberToken}`, 
          method : 'post',
          headers : {
              "Accept" : "application/json",
              'Content-Type': 'application/json',
              'Cache-Control': 'no-cache',
              'Pragma': 'no-cache',
              'Expires': '0',
          },
          data : JSON.stringify(filter)
        };
        trackVersions = await HarvestService.loadHarvestData(reqObj).then((resp) => {
          // console.log("Track version Data : ", resp);
          return resp?.Tracks[0]?.AlternateTracks;
          
        }).catch((err) => {
          console.log("Error Loading Track Versions : ", err);
          toast(({ closeToast }) => <ErrorToast message={"Error Loading Track Versions."} />);
        }).finally(() => {
          setVersionLoading(false);
        })
        // console.log("alternater versions : ", trackVersions);
        setAlternateVersions(trackVersions);
      }
      //TODO : Remove this block 
      else {
        let altVer = {
          album: { title: props.album },
          artists_publishing_ownerships: [
            {
              artist: { full_name: props.artistName },
              rights_type: { key: props.rights_type },
            },
          ],
          master_ownerships: [{ label: { label_name: props.producer } }]
        };

        setAlternateVersions([{ ...altVer }]);
      }
      setExpand(expandval);
      props.setExpandedTrackId(trackId);


      // await MewoService.loadMewoData(reqObj).then((res) => {
      //   if (res) {
      //     if (res?.length > 0) {
      //       setAlternateVersions(res);
      //     } else {
      //       let altVer = {
      //         album: { title: props.album },
      //         artists_publishing_ownerships: [
      //           {
      //             artist: { full_name: props.artist.full_name },
      //             rights_type: { key: props.rights_type },
      //           },
      //         ],
      //         master_ownerships: [{ label: { label_name: props.producer } }]
      //       };

      //       setAlternateVersions([{ ...altVer }]);
      //     }
      //     setExpand(expandval);
      //     props.setExpandedTrackId(trackId);
      //   } else {
      //     Helper.handleError(res);
      //   }
      // })
      //   .catch((err) => {
      //     toast(({ closeToast }) => (
      //       <ErrorToast message={"Error Loading Track Versions : " + err?.response?.data?.message} />
      //     ));

      //   });
    } else {
      setExpand(expandval);
    }
  };

  const handleProjectModal = (trackId) => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }
    // props.displayProjectModal(trackId);
    
    trackContext.setTrackToBeAddedToProject(trackId);
    trackContext.setShowProjectModal(true);

  };


  const handleThumbPrintSearch = async (props) => {
    trackContext.setShowLoaderMagic(true);

    let reqObj = {
      url: 'public/search',
      method: 'post',
      data: {
        "query": "",
        "options":
        {
          "trackId": props.trackId,
          "filters": {
            exclude: [],
            ...props.searchTags,
          },
          "size": Constants.MEWO_TRACK_SEARCH_BATCH_SIZE,
          "search_descriptions": trackContext.searchDescription ? trackContext.searchDescription : false
        }
      }
    };
    await MewoService.loadMewoData(reqObj).then(res => {
      if (res?.hits) {
        let newRes = res.hits;
        let [, ...magicWand] = newRes;
        trackContext.setIsLoading(false);
        trackContext.setShowLoaderMagic(false);
        trackContext.setTrackData(magicWand);
        trackContext.setTotaltracks(res.total.value);

      } else {
        Helper.handleError(res);
      }
    }).finally(() => {
      trackContext.setShowLoaderMagic(false);
    });

    let filter = trackContext.trackFilter
    filter.selectedChildTags = []
    filter.selectedTags = []
    filter.url = ""
    filter.searchId = "";
    filter.fileName = "";
    filter.searchText = "";
    filter.searchTitle = props.title;
    filter.trackId = props.trackId;
    trackContext.setTrackFilter(filter);
    if (trackContext.path === "/" ||
      trackContext.path.startsWith("/search/track/") ||
      trackContext.path.startsWith("/artist/") ||
      trackContext.path.startsWith("/playlists/") ||
      trackContext.path.startsWith("/album/")
    ) {
      localStorage.setItem("filter_music", JSON.stringify(filter));
    }
    if (trackContext.path === "/sound-design" || trackContext.path.startsWith("/sound-design/search/track/")
    ) {
      localStorage.setItem("filter_soundfx", JSON.stringify(filter));

    }

    if (trackContext.path.startsWith("/playlists/")
    ) {
      localStorage.setItem("filter_playlist", JSON.stringify(filter));
    }

    if (trackContext.path.startsWith("/album/")
    ) {
      localStorage.setItem("filter_album", JSON.stringify(filter));
    }

  };

  const handleAddTrackToFavorites = async(trackData) => {
    if (!trackContext.validateUser(Constants.ACTION.FAVOURITE)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.FAVOURITE);
      return;
    }
    props.setFavingTracks([...props.favingTracks, trackData.trackId]);
    const dataObj = {
      actionType : Constants.ACTION.FAVOURITE,
      trackId : trackData.trackId,
      title : trackData.title,
      trackDesc : trackData.description || "",
      trackData : {
        albumId : trackData.albumId,
        albumName : trackData.album,
        artistName : trackData.artistName,
        duration : trackData.duration,
        bpm : trackData.bpm
      }
    } 
    await API.addTrackToFavorites(dataObj).then((res) => {
      if (res.success) {
        // const favs = JSON.parse(localStorage.getItem("favs") || "[]");
        // if(favs.length === 0 || favs?.indexOf(trackData.trackId) < 0){
        //   favs.push(trackData.trackId)
        // }else{
        //   favs.length > 0 && favs.splice(favs.indexOf(trackData.trackId), 1);
        // }

        localStorage.setItem("favs", JSON.stringify(res.favorites));
        setFavs(Object.keys(res.favorites));
        //changing filterTrackIds if its on favorites page 
        (props.pageId === "favourites" && props.commandOnChange) && props.commandOnChange(Object.keys(res.favorites));
        toast(({ closeToast }) => <SuccessToast message={res.mssg} />);
        
      } else {
        console.log("Adding in favorite list failed.", res);
        toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
      }
    }).catch(err => {
      console.log("Adding in favorite list failed.", err);
      toast(({ closeToast }) => <ErrorToast message={"Adding in favorite list failed."} />);
    }).finally(()=>{
      const tempData = props.favingTracks;
      tempData?.length > 0 && tempData.splice(tempData.indexOf(trackData.trackId), 1);
      props.setFavingTracks(tempData);
    });

  };

  const handleClose = () => {
    setShowDownloadModal(false);
  };

  const handleDownloadTrack = async (event, trackId) => {
    let cachedUserData = JSON.parse(CookieManager.getCookie("user-data"));
    if (!trackContext.validateUser(Constants.ACTION.DOWNLOAD)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
      return;
    }
    let currentTarget = event.currentTarget;

    let userData = { id: cachedUserData._id };
    if (cachedUserData?.userType === "ADMIN" || cachedUserData?.userType === "SUPER_ADMIN")
      userData = { id: cachedUserData.email, userType: "ADMIN" };
    await API.validateSubscription(userData.id, userData.userType).then(async (resp) => {
      if (resp?.success) {
        if (resp.data?.userType === "FREE" || !resp.data?.subscribed) {
          trackContext.setShowSubscribePopup(true);
          trackContext.setUserAction(Constants.ACTION.DOWNLOAD);
        } else {
          CookieManager.setCookie("user-data", JSON.stringify(resp.data));
          await API.getDownloadTracks(trackId).then((res) => {
            if (res?.audiofile !== undefined && res.audiofile !== null) {
              setHdmp3File(res.audiofile?.hd_mp3?.url);
              setOriginalFile(res.audiofile?.original.url);
              setDownloadModalPosition(currentTarget);
              setChilddownloadModalPosition(currentTarget);
              setShowDownloadModal(true);
            } else {
              Helper.handleError(res);
            }
          });
        }
      } else {
        toast(({ closeToast }) => <ErrorToast message={resp.mssg} />);
      }
    });

  };

  const handleDownloadArchive = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => {
      if (res?.length > 0) {
        toast(({ closeToast }) => (
          <SuccessToast message="Check your email, you have been sent a link to download the files" />
        ));
      } else {
        toast(({ closeToast }) => <ErrorToast message={res.message} />);
      }
    })
      .catch((err) => {
        Helper.handleError(err);

      });
  };

  const handleArchiveDownload = (trackId, quality) => {
    API.downloadArchiveTrack(trackId, quality).then((res) => {
      //success : response  = ["taskId"]
      //fail : response : { "status": 400, "message": "\"documentIds\" is required. \"docId\" is not allowed.", "key": "validation_error", "stack": {}, "reqId": "9022499d-9b2b-4edc-9397-c8f8372a83ea" }
      if (Array.isArray(res) && res.length) {
        toast(({ closeToast }) => (
          <SuccessToast message="Check your email, you have been sent a link to download the files." />
        ));
      } else {
        toast(({ closeToast }) => <ErrorToast message={res.message} />);
      }

    });
  };

  const setDownloadHistory = (trackId) => {
    API.setDownloads(trackId).then((res) => {
      const downloadlist = JSON.parse(localStorage.getItem("download")) || [];
      downloadlist.push(trackId);
      setDownload(downloadlist);
      localStorage.setItem("download", JSON.stringify(downloadlist));
    });
  };


  const addSearchTag = (tagId, tagName) => {
    let newTrackFilter = { ...trackContext.trackFilter };
    let newTags = { ...newTrackFilter.searchTags };
    let tags_not = newTags.tags_not || [];
    let Contexttags = newTags.tags || [];
    Contexttags.push(tagId);
    tags_not = tags_not.filter((itemnot) => itemnot !== tagId);
    newTags.tags = Contexttags;
    newTags.tags_not = tags_not;
    newTrackFilter.searchTags = newTags;
    newTrackFilter.fetchList = true;
    newTrackFilter.url = "";
    trackContext.setTrackFilter(newTrackFilter);
  };
  const removeSearchTag = (tagId, tagName) => {
    let newTrackFilter = { ...trackContext.trackFilter };
    let newTags = { ...newTrackFilter.searchTags };
    let tags_or = newTags.tags_or || [];
    let contexttags = newTags.tags || [];
    let tags_not = newTags.tags_not || [];
    if (tags_or.some((item1) => item1.includes(tagId))) {
      tags_not.push(tagId);
      tags_or = tags_or.filter((item) => {
        if (item.every((subItem) => tags_not.includes(subItem))) {
          tags_not = tags_not.filter((itemnot) => !item.includes(itemnot));
          return false;
        }
        return true;
      });
    }
    if (contexttags.includes(tagId)) {
      contexttags = contexttags.filter((item) => item !== tagId);
    }
    newTags.tags_or = tags_or;
    newTags.tags_not = [...tags_not];
    newTags.tags = contexttags;
    newTrackFilter.searchTags = newTags;
    trackContext.setTrackFilter(newTrackFilter);
  };

  const handleMagicWandClick = (trackData) => {
    if (!trackContext.validateUser(Constants.ACTION.SEARCH)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.SEARCH);
      return;
    }
    //TODO : change this as we change musicFilter obj
    const tempFilter = CookieManager.getCookie("harmix-music-filter")?.length > 0 ? JSON.parse(decodeURIComponent(CookieManager.getCookie("harmix-music-filter"))) : { "searchText" : "", "type" : Constants.SEARCH_TYPE.text};
    tempFilter.type = Constants.SEARCH_TYPE.track;
    tempFilter.searchText = trackData.title;
    tempFilter.searchRef = trackData.id;
    tempFilter.segment = null;
    CookieManager.setCookie("harmix-music-filter", encodeURIComponent(JSON.stringify(tempFilter)));
    history.push(`/library/${trackData.id}`, {searchedTrackData : {...trackData}})
  }

  const alternateVersionsProps = {
    albumName : props.album,
    alternateVersions,
    favs,
    setFavs,
    handleAddTrackToFavorites,
    playTrack,
    magicWandSearch,
    handleProjectModal,
    downloadTrack,
    handleClose,
    downloadingTracks : props.downloadingTracks,
    favingTracks : props.favingTracks,
    // setDownloadingTracks : props.setDownloadingTracks
    // setDownloadHistory,
    // handleMagicWandClick
  };

  const handleLoaderWithThumbPrint = () => {
    let newFilter = filterMenu;
    newFilter = newFilter.map((item) => {
      item.count = 0
      return item;
    })
    trackContext.setFilterMenu(newFilter);
    localStorage.setItem("filterMenu", JSON.stringify(newFilter));

    setFilterSubMenu([]);
    setFilterSubMenuchild([]);
    //trackContext.setClearData(true)
    // setShowMayaLoader(true)
    handleThumbPrintSearch(props)

    let searchTitle = ""
    if (props) {

      searchTitle = props.title
    } else {

      searchTitle = trackContext.trackFilter.searchTitle
    }

    if (trackContext.path.startsWith("/search")
      || trackContext.path === "/"
      || trackContext.path.startsWith("/album")
      || trackContext.path.startsWith("/artist")
      || trackContext.path.startsWith("/playlists")
    ) {
      //setting filter data
      if (searchTitle) {
        let tempData = JSON.parse(localStorage.getItem("filterMenu") || {}); tempData.searchTitle = searchTitle;
        localStorage.setItem("filterMenu", JSON.stringify(tempData));
      }
      history.push(`/search/track/`);

    }
    else {
      (
        trackContext.path.startsWith("/playlists/") ? history.push(`/playlists/${playlistId}`)
          :
          trackContext.path.startsWith("/album/") ? history.push(`/album/${albumId}`) :
            history.push(`/sound-design/search/track/`))
    }


  }

  const loadAlbumData = (albumId) => {
    if (!albumId?.length) {
      toast(({ closeToast }) => <ErrorToast message={"Album Id not specified."} />);
      return;
    } else {
      history.push(`/album/${albumId}`);
    }
  }

  const loadArtistData = (artistId) => {
    if (!artistId?.length) {
      toast(({ closeToast }) => <ErrorToast message={"Artist Id not specified."} />);
      return;
    } else {
      history.push(`/artist/${artistId}`);
    }
  }

  return (
    <div
      id={props.trackId}
      className={`track-item md:w-full  z-[-10] lg:w-full flex flex-wrap bg-white cursor-mouse hover:bg-red-200 text-red-500 transition ease-in-out p-0.5 my-0.5 w-full ${!expand && "rounded-2xl"}`}
      // style={{ backgroundColor: props.pageId !=="album" && "#ffeff8"}}
      style={{ background: isHovered ? "#ebedf0" : expand ? "#f6f6f6" : "rgb(var(--bg))", color: "rgb(var(--text))", position: "relative", boxShadow: "0 4px 16px rgb(var(--box_sh))"}}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >

      <div className="flex  w-full z-[-100] lg:flex-row lg:justify-between">
        <div className="w-full z-[-50] lg:w-2/6 flex justify-around lg:justify-start "
        // style={{width:"45%"}}
        >
          <div className="flex items-center gap-2">
            {/* Album Image Section */}
            <div className="z-[-10] w-3/4  flex justify-center   sm:justify-start">
              {props.albumId ? (
                <Link className="self-center" to={`/album/${props?.albumId}`}>
                  <img
                    src={Helper.getArtworkURL(props?.albumId) || defaultImage}
                    alt=""
                    onError={(e) => {     e.target.onerror = null;     e.target.src = defaultImage   }}
                    className="w-full p-0.5"
                    loading="lazy"
                    style={{width:"100px"}}
                  />
                </Link>
              ) : (
                <img
                  src={defaultImage}
                  alt="Default album cover"
                  style={{width:"100px"}}
                  className=" w-full p-0.5 shadow-md"
                />
              )}
            </div>

            {/* Play/Pause Button */}
            <div className="flex w-1/4   justify-center">
              <button
                aria-label="Play or Pause"
                className="p-0.5 rounded-full border border-gray-400 shadow-sm flex items-center justify-center"
                onClick={() => playTrack(props)}
                style={{background: "rgb(var(--pink))", color: "rgb(var(--text))"}}
              >
                {trackContext.playPause &&
                  props.trackId === trackContext.currentTrackDetail.id &&
                  trackContext.playingFrom === props.pageId ? (
                  <PauseIcon 
                    style={{color: "rgb(var(--bg))", height:"30px", width:"30px"}}/>
                ) : (
                  <PlayArrowIcon style={{color: "rgb(var(--bg))", height:"30px", width:"30px"}}/>
                )}
              </button>
            </div>
          </div>

          <div
            className="w-full sm:w-7/12 lg:w-3/4 p-2    cursor-pointer"
            onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
            style={{ overflow: "hidden", color: "rgb(var(--text)) !important"}}
          >
            <div className="t-title font-semibold text-sm sm:text-base" 
              style={expand ? {} : {
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}>
              {props?.title?.toLowerCase()}
            </div>
            <div className="t-artist text-xs sm:text-sm" 
              style={expand ? {} : {
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}>
              {props.artistName}
            </div>
            <div className={`t-desc text-xs sm:text-sm ${expand ? "text-all" : ""}`}
              style={expand ? {} : {
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {props?.description !== undefined && props?.description?.length > 0 ? props.description : ""}
            </div>
          </div>
          <div className="flex items-center gap-1 lg:hidden">
            <IconButton onClick={handleClick} style={{ padding: 4 }}>
              <MoreVertIcon style={{ fontSize: 20, color: "rgb(var(--text))" }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose2}
              getContentAnchorEl={null}
              PaperProps={{
                elevation: 4,
                style: {
                  borderRadius: 10,
                  paddingTop: 4,
                  paddingBottom: 4,
                  background: "rgb(var(--canvas))",
                  width: "70px",
                },
              }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
            >
              {!props.isVersion &&
                <MenuItem
                  onClick={() => {handleMagicWandClick({
                                title: props.title, 
                                id:props.trackId,
                                albumId : props.albumId, 
                                artist : props.artistName, 
                                duration : props.duration
                              }); handleClose2();}}
                  >
                  {/* <ListItemIcon>
                    <ThumbPrint  className="thumbprint-icon w-8 sm:w-6 sm:mb-4 sm:mt-5 sm:ml-2 sm:right-0 self-center cursor-pointer"
                                      // onClick={
                                      //   handleLoaderWithThumbPrint
                                      //   // handleThumbPrintSearch(props.currentTrackDetail.id)

                                      // }
                                    
                                  />
                  </ListItemIcon> */}
                  <ListItemIcon>
                    {/* <JoinInner /> */}
                    {Helper.getSearchIcon("rgb(var(--text))")}
                  </ListItemIcon>

                  {/* <ListItemText primary="Magic Wand" /> */}
                </MenuItem> 
              }
              <MenuItem 
                onClick={() =>{
                                    handleProjectModal({trackId : props.trackId, albumId : props.albumId, artworkRef : Helper.getArtworkURL(props.albumId), audioRef : Helper.playTrackURL(props.trackId)});
                                    handleClose2();
                  }   }>
                <ListItemIcon>
                  <CreateNewFolderOutlinedIcon
                                  style={{ fontSize: "28px", color: "rgb(var(--text))" }}
                                
                                  className="m-1 self-center right-0 cursor-pointer text-gray-700 block"
                              />
                </ListItemIcon>
                {/* <ListItemText primary="Add to project" /> */}
              </MenuItem>
           
            <MenuItem
              onClick={() => {
                handleAddTrackToFavorites({...props});
                handleClose2();
              }}
            >
              <ListItemIcon>
                {favs?.indexOf(props.trackId) > -1 ? (
                  <FavoriteIcon
                    // fontSize="medium"
                    className="text-red-600 self-center right-0 m-1 cursor-pointer hover:scale-110 transition-transform duration-200"
                    style={{fontSize: "28px"}}
                  />
                ) : (
                  <UnFavoriteIcon
                    // fontSize="medium"
                    className="self-center right-0 cursor-pointer m-1 hover:text-red-600 transition-colors duration-200"
                    style={{fontSize: "28px", color: "rgb(var(--text))"}}
                  />
                )}
              </ListItemIcon>
              {/* <ListItemText primary={isFav ? "Unfavourite" : "Favourite"} /> */}
            </MenuItem>

            <MenuItem
              onClick={(event) => {
                handleDownloadClick(event);
                handleClose2();
              }}
            >
              <ListItemIcon>
                {!download ? (
                  downloadingTrack?.length > 0 ? 
                  <div className="pt-2" ><CircularProgress size='18px'/></div> : 
                  <DownloadForOfflineIcon
                    // fontSize="small"
                    className="self-center right-0 cursor-pointer m-1 transition-colors duration-200"
                    style={{fontSize: "28px", color: "rgb(var(--text))"}}
                  />
                ) : (
                  downloadingTrack?.length > 0 ? 
                  <div className="pt-2" ><CircularProgress size='18px'/></div> : 
                  <GetAppIcon
                    // fontSize="small"
                    className="self-center right-0 cursor-pointer m-1 transition-colors duration-200"
                    style={{fontSize: "28px", color: "rgb(var(--text))"}}
                  />
                )}
              </ListItemIcon>
              {/* <ListItemText primary="Download" /> */}
            </MenuItem>
            {props.lyrics?.length > 0 &&
              <MenuItem
                onClick={(event) => {
                  handleLyricClick(event);
                  handleClose2();
                }}
              >
                <ListItemIcon>
                  
                <LyricsOutlinedIcon
                  id={`lyricBtn-${props.trackId}`}
                  className="right-0 self-center cursor-pointer m-1"
                  onClick={(event) => { handleLyricClick(event)}}
                  style={{ fontSize: "28px", color: "rgb(var(--text))"}}
                  title = "Lyrics"
                />
                </ListItemIcon>
                {/* <ListItemText primary="Lyrics" /> */}
              </MenuItem>
            }
            {props.versions != undefined && props.versions > 0 &&
              <MenuItem
                onClick={() => {
                  fetchAltVersion(props.trackId, props.versions, !expand);
                  handleClose2();
                }}
              >
                <ListItemIcon>
                  <div className="w-8 h-8 text-white text-xs flex items-center justify-center rounded-full m-1"
                    style={{background: "rgb(var(--pink))", color: "rgb(var(--bg))"}}>
                    <span>
                      <span className="mb-1"><b>+{props.versions}</b></span>
                      {/* <span><b>{props.versions}</b></span> */}
                    </span>
                  </div>
                </ListItemIcon>
                {/* <ListItemText primary={`Versions (${props.versions})`} /> */}
              </MenuItem>
            }
            </Menu>
          </div>
        </div>
       <div className="w-full lg:w-4/6 flex flex-col lg:flex-row justify-start lg:justify-between px-0 hidden lg:flex self-center">
     
       <div className="w-full lg:w-7/12 flex justify-start self-center hidden lg:block">
          {props.waveform?.length > 0 && 
          <>
          {/* <img
            src={props.waveform}
            alt=""
            className="w-full"
            loading="lazy"
          /> */}
          <WaveformWithHighlights
            waveformDataUrl={Helper.getWaveformDataURL(props.trackId)}
            // width={1000}
            // height={120}
            ranges={props.highlights?.length > 0 ? [...props.highlights] : []}
            ID={props.trackId}
            duration={props.duration}
          />
          </>
          }
        </div>

        <div className="flex  sm:w-full  lg:w-3/12 self-center  flex-row px-2 justify-start gap-x-6 my-2 hidden lg:flex"
          style={{color: "rgb(var(--text))"}}>
            <div className="lg:w-4/6 sm:w-9/12 flex lg:gap-x-4 sm:gap-16 grid-cols-3 place-items-center justify-evenly">
              <span className="w-8 lg:m-0 sm:mr-4 pt-2 cursor-pointer hover:text-blue-600"
                onClick={() => magicWandSearch({ id: props.trackId, title: props.title, albumId : props.albumId, artist : props.artistName, duration : props.duration })}
                title = "Similar Search">
              {/* <JoinInnerIcon
                className="w-8  sm:w-6 sm:right-0 self-center cursor-pointer hover:text-blue-600"
                onClick={() => magicWandSearch({ id: props.trackId, title: props.title, albumId : props.albumId, artist : props.artistName, duration : props.duration })}
                style={{ fontSize: "26px"}}
                title = "Similar Search"
              /> */}
              {Helper.getSearchIcon("rgb(var(--text))")}
              </span>

              <span className="w-8">
              {props.versions !== undefined && props.versions > 0 &&
                <div className="w-6 h-6 text-white text-xs flex items-center justify-center rounded-full mt-1"
                  style={{background: "rgb(var(--pink))", color: "rgb(var(--bg))"}}>
                  <span>
                    <span className="mb-1"><b>+{props.versions}</b></span>
                    {/* <span><b>{props.versions}</b></span> */}
                  </span>
                </div>
                // <div className="self-center" style={{color : "rgb(var(--pink))", fontSize: "medium"}}>
                //   <span className="mb-2"><b>+</b></span>
                //   <span><b>{props.versions}</b></span>
                // </div>
              }
              </span>
              <span className="w-8 lg:p-0 sm:pl-6">
              {props.lyrics?.length > 0 &&
              <LyricsOutlinedIcon
                id={`lyricBtn-${props.trackId}`}
                className="w-8 sm:w-6 sm:right-0 self-center cursor-pointer hover:text-blue-600"
                onClick={(event) => { handleLyricClick(event)}}
                style={{ fontSize: "22px", marginTop : "5px"}}
                title = "Lyrics"
              />}
              </span>
            </div>
            <div className="flex-wrap lg:w-2/6 sm:w-3/12 justify-end lg:justify-center lg:self-center">
              <div className=" text-center  w-full text-xs self-center  block font-medium">
                {props.bpm !== undefined && props.bpm > 0 ? Math.round(props.bpm) + " BPM" : null}
              </div>
              <div className=" text-center w-full text-xs self-center block font-medium">
                {props.duration &&
                  new Date(props.duration * 1000).toISOString().substr(14, 5)}
              </div>
            </div>
        </div>

         
        <div className="w-full flex gap-x-2  lg:w-2/12  px-2 lg:px-0 lg:gap-x-2 sm:gap-x-3 grid grid-cols-4 place-items-center justify-evenly lg:justify-end self-center hidden lg:grid">
         
          {favs?.indexOf(props.trackId) !== -1 ? (
            props.favingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='16px'/></div> : 
            <FavoriteIcon
              onClick={() => handleAddTrackToFavorites({...props})}
              style={{ fontSize: "24px"}}
              className="self-center sm:right-0 cursor-pointer text-red-600 "
            />

          ) : (
            props.favingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='18px'/></div> : 
            <UnFavoriteIcon
              onClick={() => handleAddTrackToFavorites({...props})}
              style={{ fontSize: "24px"}}
              className="self-center sm:right-0 cursor-pointer hover:text-red-600"
            />
          )}
          <CreateNewFolderOutlinedIcon
            style={{ fontSize: "26px"}}
            onClick={() => handleProjectModal({trackId : props.trackId, albumId : props.albumId, artworkRef : Helper.getArtworkURL(props.albumId), audioRef : Helper.playTrackURL(props.trackId)})}
            className="self-center sm:right-0 cursor-pointer hover:text-blue-600"
          />
          {download?.indexOf(props.trackId) !== -1 ? (
            props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='16px'/></div> : 
            <DownloadForOfflineIcon
              // onClick={(event) => downloadTrack(props.trackId)}
              onClick={(event) => { handleDownloadClick(event)}}
              style={{ fontSize: "22px" }}
                className="trackicon  mt-5  self-center right-0 cursor-pointer  block"
            />
          ) : (
            props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='16px'/></div> : 
            <SaveAltIcon
              onClick={(event) => { handleDownloadClick(event)}}
              style={{ fontSize: "24px"}}
              className="self-center right-0 cursor-pointer block hover:text-blue-600"
            />
          )}
          {expand && props.expandedTrackId === props.trackId ? (
            <ExpandLessIcon
              onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
              style={{ fontSize: "25px" }}
              className="self-center  cursor-pointer hover:text-blue-600"
            />
          ) : (
            <ExpandMoreIcon
              onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
              style={{ fontSize: "25px" }}
              className="self-center  cursor-pointer hover:text-blue-600"
            />
          )}
        </div>

        {/* Action buttons for mobile view  */}
        {/* <div className="w-full flex gap-x-2  px-1 grid grid-cols-8 place-items-center justify-evenly self-center sm:grid lg:hidden">
          <div className="flex-wrap justify-start lg:justify-center lg:self-center">
            <div className=" text-center  w-full text-xs self-center  block font-medium border border-black rounded-xl p-0.25">
              {props.bpm !== undefined ? Math.round(props.bpm) + " BPM" : null}
            </div>
            <div className=" text-center w-full text-xs self-center block font-medium">
              {props.duration &&
                new Date(props.duration * 1000).toISOString().substr(14, 5)}
            </div>
          </div>
          
          <span className="w-8">
            {props.versions !== undefined && props.versions > 0 &&
              <div className="w-6 h-6 text-white text-xs flex items-center justify-center rounded-full mt-1"
                style={{background: "rgb(var(--pink))", color: "rgb(var(--bg))"}}>
                <span>
                  <span className="mb-1"><b>+{props.versions}</b></span>
                </span>
              </div>
            }
          </span>
          <span className="w-8 lg:p-0 sm:pl-6">
            {props.lyrics?.length > 0 &&
            <LyricsOutlinedIcon
              id={`lyricBtn-${props.trackId}`}
              className="w-8 sm:w-6 sm:right-0 self-center cursor-pointer hover:text-blue-600"
              onClick={(event) => { handleLyricClick(event)}}
              style={{ fontSize: "22px", marginTop : "5px"}}
              title = "Lyrics"
            />}
          </span>
          
          <span className="w-8 lg:m-0 sm:mr-4 pt-2 cursor-pointer hover:text-blue-600"
              onClick={() => magicWandSearch({ id: props.trackId, title: props.title, albumId : props.albumId, artist : props.artistName, duration : props.duration })}
              title = "Similar Search">
            {Helper.getSearchIcon("rgb(var(--text))")}
          </span>

          {favs?.indexOf(props.trackId) !== -1 ? (
            props.favingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='16px'/></div> : 
            <FavoriteIcon
              onClick={() => handleAddTrackToFavorites({...props})}
              style={{ fontSize: "24px"}}
              className="self-center sm:right-0 cursor-pointer text-red-600 "
            />

          ) : (
            props.favingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='18px'/></div> : 
            <UnFavoriteIcon
              onClick={() => handleAddTrackToFavorites({...props})}
              style={{ fontSize: "24px"}}
              className="self-center sm:right-0 cursor-pointer hover:text-red-600"
            />
          )}
          <CreateNewFolderOutlinedIcon
            style={{ fontSize: "26px"}}
            onClick={() => handleProjectModal({trackId : props.trackId, albumId : props.albumId, artworkRef : Helper.getArtworkURL(props.albumId), audioRef : Helper.playTrackURL(props.trackId)})}
            className="self-center sm:right-0 cursor-pointer hover:text-blue-600"
          />
          {download?.indexOf(props.trackId) !== -1 ? (
            props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='16px'/></div> : 
            <DownloadForOfflineIcon
              // onClick={(event) => downloadTrack(props.trackId)}
              onClick={(event) => { handleDownloadClick(event)}}
              style={{ fontSize: "22px" }}
                className="trackicon  mt-5  self-center right-0 cursor-pointer  block"
            />
          ) : (
            props.downloadingTracks?.indexOf(props.trackId) > -1 ? 
            <div className="p-0.5" ><CircularProgress size='16px'/></div> : 
            <SaveAltIcon
              onClick={(event) => { handleDownloadClick(event)}}
              style={{ fontSize: "24px"}}
              className="self-center right-0 cursor-pointer block hover:text-blue-600"
            />
          )}
          {expand && props.expandedTrackId === props.trackId ? (
            <ExpandLessIcon
              onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
              style={{ fontSize: "25px" }}
              className="self-center  cursor-pointer hover:text-blue-600"
            />
          ) : (
            <ExpandMoreIcon
              onClick={() => fetchAltVersion(props.trackId, props.versions, !expand)}
              style={{ fontSize: "25px" }}
              className="self-center  cursor-pointer hover:text-blue-600"
            />
          )}
        </div> */}
       
        {showLyricModal && 
          <Popover
          anchorEl={lyricModalPosition}
          open={Boolean(showLyricModal)}
          onClose={() => {setShowLyricModal(false)}}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          PaperProps={{
            sx: {
              width: 100,
              maxWidth: 100,
              height : 380,
              maxHeight: 380,
              p: 0,
              borderRadius: "16px",
              border: "2px solid #ff4da6",
              boxShadow:
                "0 20px 40px rgba(0,0,0,0.15), 0 6px 12px rgba(0,0,0,0.08)",
              backgroundColor: "#fff",
              overflow: "hidden",
            },
          }}
        >
        <Box
          sx={{
            px: 2,
            py: 1.5,
            width: "300px",
            maxWidth: "300px",
            height: "auto",
            overflowY: "auto",
            scrollbarWidth: "thin",
            border: "2px solid rgb(var(--pink))",
            borderRadius: "10px",
            boxShadow: "0px 3px 10px rgba(var(--shadow))",
            background: "rgb(var(--pink))",
            color: "white",
            "&::-webkit-scrollbar": {
              width: 6,
            },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: 10,
            },
          }}
        >
          <Typography>{props.lyrics}</Typography>
        </Box>
      </Popover>}

        <Menu
          id="customized-menu"
          anchorEl={downloadModalPosition}
          open={Boolean(showDownloadModal)}
          onClose={handleClose}
          style={{ width: "320px" }}
        >
          <MenuItem
            onClick={() => { downloadTrack(props.trackId, "aiff"); setShowDownloadModal(false) }}
            className="card-action"
          >
            <span className="card-action-text">
              AIFF
            </span>
          </MenuItem>
          <MenuItem
            onClick={() => { downloadTrack(props.trackId, "mp3"); setShowDownloadModal(false) }}
            className="card-action"
          >
            <span className="card-action-text">
              MP3
            </span>
          </MenuItem>
          <MenuItem
            onClick={() => { downloadTrack(props.trackId, "wav"); setShowDownloadModal(false) }}
            className="card-action"
          >
            <span className="card-action-text">
              WAV
            </span>
          </MenuItem>
        </Menu>
       </div>
      </div>

      {expand && props.expandedTrackId === props.trackId && (
        <div className="alternative-versions-wrapper w-full">
          {/* <div className="hidden lg:w-12/12 lg:flex lg:flex-wrap lg:text-gray-600 lg:my-4 lg:self-center">
            <Tabs
              variant="scrollable"
              scrollButtons="on"
              indicatorColor="primary"
              textColor="primary"
              className="p-3 w-full"
              value={0}
            >
              {props.tags?.sort((a, b) => (a.names[0].value < b.names[0].value ? -1 : 1))
                ?.map((tag, index) => (
                  <div
                    key={tag.id}
                    value={index}
                    onClick={() => {
                      if (
                        !(
                          (searchTags.tags_or?.some((item1) =>
                            item1.includes(tag.id)
                          ) &&
                            !searchTags.tags_not?.includes(tag.id)) ||
                          searchTags.tags?.includes(tag.id)
                        )
                      )
                        addSearchTag(
                          tag.id,
                          [...tag.names]?.map((eachTagName) =>
                            eachTagName.locale === "en"
                              ? eachTagName.value
                              : null
                          )
                        );
                    }}
                    className={
                      (searchTags.tags_or?.some((item1) =>
                        item1.includes(tag.id)
                      ) &&
                        !searchTags.tags_not?.includes(tag.id)) ||
                        searchTags.tags?.includes(tag.id)
                        ? `flex pt-1 pb-1 pl-2 pr-2 mr-1 mb-1 text-xs border text-symTextGrey border-symStrokeGrey bg-symbgGray rounded-full cursor-pointer`
                        : `flex pt-1 pb-1 pl-2 pr-2 mr-1 mb-1 text-xs border text-symTextGrey border-symStrokeGrey rounded-full cursor-pointer hover:bg-symbgGray hover:scale-75`
                    }
                  >
                    {[...tag.names]?.map((eachTagName) =>
                      eachTagName.locale === "en" ? eachTagName.value : null
                    )}
                    {((searchTags.tags_or?.some((item1) =>
                      item1.includes(tag.id)
                    ) &&
                      !searchTags.tags_not?.includes(tag.id)) ||
                      searchTags.tags?.includes(tag.id)) && (
                        <Close
                          onClick={(e) => {
                            e.stopPropagation();
                            removeSearchTag(
                              tag.id,
                              [...tag.names]?.map((eachTagName) =>
                                eachTagName.locale === "en"
                                  ? eachTagName.value
                                  : null
                              )
                            );
                          }}
                          className="mt-1 ml-1"
                        />
                      )}
                  </div>
                ))}
            </Tabs>
          </div>
          <div className="lg:hidden w-full mr-2 flex flex-wrap text-gray-600 self-center">
            {props.tags?.sort((a, b) => (a.names[0].value < b.names[0].value ? -1 : 1))
              ?.map((tag, index) => (
                <div
                  key={tag.id}
                  value={index}
                  onClick={() => {
                    if (
                      !(
                        (searchTags.tags_or?.some((item1) =>
                          item1.includes(tag.id)
                        ) &&
                          !searchTags.tags_not?.includes(tag.id)) ||
                        searchTags.tags?.includes(tag.id)
                      )
                    )
                      addSearchTag(
                        tag.id,
                        [...tag.names]?.map((eachTagName) =>
                          eachTagName.locale === "en" ? eachTagName.value : null
                        )
                      );
                  }}
                  className={
                    (searchTags.tags_or?.some((item1) =>
                      item1.includes(tag.id)
                    ) &&
                      !searchTags.tags_not?.includes(tag.id)) ||
                      searchTags.tags?.includes(tag.id)
                      ? `flex pt-1 pb-1 pl-2 pr-2 mr-2 mb-2 text-xs border text-symTextGrey border-symStrokeGrey bg-symbgGray rounded-full cursor-pointer`
                      : `flex pt-1 pb-1 pl-2 pr-2 mr-2 mb-2 text-xs border text-symTextGrey border-symStrokeGrey rounded-full cursor-pointer hover:bg-symbgGray hover:scale-75`
                  }
                >
                  {[...tag.names]?.map((eachTagName) =>
                    eachTagName.locale === "en" ? eachTagName.value : null
                  )}
                  {((searchTags.tags_or?.some((item1) =>
                    item1.includes(tag.id)
                  ) &&
                    !searchTags.tags_not?.includes(tag.id)) ||
                    searchTags.tags?.includes(tag.id)) && (
                      <Close
                        onClick={(e) => {
                          e.stopPropagation();
                          removeSearchTag(
                            tag.id,
                            [...tag.names]?.map((eachTagName) =>
                              eachTagName.locale === "en"
                                ? eachTagName.value
                                : null
                            )
                          );
                        }}
                        className="mt-1 ml-1"
                      />
                    )}
                </div>
              ))}
          </div> */}
          {/* <div className="flex flex-wrap w-1/2 mt-4">
        <div className="sm:hidden text-center ml-2 w-2/12 text-sm self-center block text-black font-medium">
          {props.bpm !== undefined ? Math.round(props.bpm) + "BPM" : null}
        </div>
        <div className="sm:hidden text-center ml-12 w-2/12 text-sm self-center block text-black font-medium">
          {props.duration &&
            new Date(props.duration * 1000).toISOString().substr(14, 5)}
        </div>
      </div> */}
          
          {props.waveform?.length > 0 && 
          <div className="flex flex-wrap w-full lg:hidden">
          {/* <img
            src={props.waveform}
            alt=""
            className="w-full"
            loading="lazy"
          /> */}
          <WaveformWithHighlights
            waveformDataUrl={Helper.getWaveformDataURL(props.trackId)}
            // width={1000}
            // height={120}
            ranges={props.highlights?.length > 0 ? [...props.highlights] : []}
            ID={props.trackId}
            duration={props.duration}
          />
          </div>
          }

          <div className="ml-1 album-info w-full">
            <div className="flex flex-wrap mt-2 w-full sm:mt-2 md:flex md:mb-4 lg:ml-2">
              <div className="pr-8 pb-2 w-2/6">
                <p className="text-title " style={{color: "rgb(var(--pink))"}}>Album</p>
                <h3 className="t-artist hover:underline font-bold">
                  <div className="cursor-pointer" onClick={() => loadAlbumData(props.albumId)}>{props.album}</div>
                </h3>
              </div>
              <div className="pr-8 pb-2 w-2/6">
                <p className="text-title" style={{color: "rgb(var(--pink))"}}>Writer(s) </p>
                {Object.keys(props.artists)?.length > 0 ? Object.keys(props.artists).map((elem) => {
                  return (
                    <div className="t-artist hover:underline font-bold font-bold cursor-pointer"
                      onClick={() => elem && loadArtistData(elem)}>
                      {props.artists[elem]}
                    </div>
                  );
                }) : (props.artistName?.length > 0 &&
                    <div className="t-artist font-bold font-bold">
                      {props.artistName}
                    </div>
                  )}
              </div>
              <div className="pr-8 pb-2 w-2/6">
                <p className="text-title text-gray-600" style={{color: "rgb(var(--pink))"}}>Producer</p>
                <h3 className="t-artist font-bold">{props.producer}</h3>
              </div>
            </div>
          </div>
          {(props.versions > 0 && alternateVersions?.length > 0) && (
            <div className="w-full lg:ml:2">
              <p className="lg:ml-3 text-title" style={{color: "rgb(var(--pink))"}}>
                Alternative versions
              </p>
              <div className="lg:px-1 py-1 lg:mx-2" >
                <AlternateTracks {...alternateVersionsProps} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}